import Link from 'next/link';
import { usePathname } from 'next/navigation';

import useAcl from '@/utils/hooks/user/useAcl';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import { aclFeatures } from '@/lib/acl/aclFeatures';
import {
    ANALYZE_ENGAGEMENT,
    ANALYZE_OVERVIEW,
    CONTENT_POSTS,
    SUBSCRIPTION_INVOICES
} from '@/lib/routes/privateRoutes';
import { CHANGE_YOUR_PLAN } from '@/lib/settings/subscriptionInvoices/steps';

import { Trans } from '@/components/tools/translation';

export const PromotedPostsUpsellBanner = () => {
    const { hasAcl } = useAcl();
    const hasPermissions = hasAcl(aclFeatures.analytic.promoted_post.read);
    const pathname = usePathname();
    const { activeSocialProfile } = useActiveSocialProfile();

    if (
        !hasPermissions &&
        (pathname === CONTENT_POSTS ||
            ((pathname === ANALYZE_OVERVIEW || pathname === ANALYZE_ENGAGEMENT) &&
                activeSocialProfile?.social_network_type === 'instagram'))
    ) {
        return (
            <div
                className="w-full bg-icoGreen-100 p-4 text-center text-xs dark:bg-icoGreen"
                data-testid="promoted-posts-upsell-banner">
                <Trans
                    i18nKey={'commons:upsell_banner.promoted_posts.text'}
                    components={{
                        bold: <span className="font-GBold" />,
                        link: (
                            <Link
                                href={{
                                    pathname: SUBSCRIPTION_INVOICES,
                                    query: { step: CHANGE_YOUR_PLAN }
                                }}
                                className="text-icoGreen underline dark:text-white"
                            />
                        )
                    }}
                />
            </div>
        );
    }
    return null;
};
